import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';

import { AppContextProvider } from '@contexts/AppContext';
import { EventProperties } from '@tracking';
import { User } from '@utils/backend-api/currentUser';
import { LeadType } from '@utils/enums';

import MarketingModalContent from './Content';
import { ModalType } from './Content/MarketingCopy';

const queryClient = new QueryClient();

export interface MarketingCopyProps {
  analytics?: EventProperties;
  articleId?: number;
  briefingGuid?: string;
  buttonText?: string;
  customUrl?: string;
  disclosure?: string;
  header?: string;
  isGdprLead?: boolean;
  leadType?: LeadType;
  modalType: ModalType;
  offerLink?: string;
  shareGuid?: string;
  subtitle?: string;
  title: string;
  trackingProps: { [key: string]: string };
  unlockContent?: boolean;
}

export interface MarketingModalProps extends MarketingCopyProps {
  guid: string;
  highlightedCta: string;
  id: number;
  initialCurrentUser?: User;
  isActiveUser?: boolean;
}

const MarketingModal = (props: MarketingModalProps) => {
  const { initialCurrentUser, isGdprLead } = props;

  return (
    <AppContextProvider initialCurrentUser={initialCurrentUser} isGdprRequired={isGdprLead}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <MarketingModalContent {...props} />
        </BrowserRouter>
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default MarketingModal;
